namespace Areas.Project {
    "use strict";

    const downloadZipButtonId = "downloadZipButton";
    
    export function downloadAttachmentLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.attachmentId; },
            "<a href= '/File/Get/Attachment/{placeholder}'>Download</a>");
    }

    export function thumbnailImage(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.attachmentId; },
            "<div style='height:150px;'><img class='thumbnail' alt='image' src='/File/Get/AttachmentThumbnail/{placeholder}'/></div>");
    }   

    export function returnToListFromTab() {
        var linkInfo = "/Project/List/Index";
        location.href = linkInfo;

    }

    export function goToEdit() {

        let viewLink = location.pathname;
        let linkInfo = viewLink.replace(/View/gi, "Edit");
        location.href = linkInfo;
    }

    export function addDownloadZipButton(e: any) {
        if ($(`#${downloadZipButtonId}`).length == 0) {
            var div = document.createElement("div");
            var toolbar = e.element.find('.dx-toolbar-after');
            $(toolbar.get(0)).prepend(div);    

            $(div).dxButton({
                elementAttr: { id: downloadZipButtonId },
                text: "Download Zip",
                icon: "arrowdown",
                type: "normal",
                disabled: true,
                onClick(elem) { downloadZip(e.component); }
            });
        }
    }     

    export function toggleDownloadZipButton(e: any) {
        if (e.selectedRowKeys.length) {
            Areas.enableButton(downloadZipButtonId);
        } else {
            Areas.disableButton(downloadZipButtonId);
        }
    }

    export function downloadZip(dataGrid: DevExpress.ui.dxDataGrid) {
        const type = dataGrid.option("type") as string;
        const selectedIds = getSelectedIds(dataGrid, type);        
        const url = `/File/Get/${type}Zip?ids=${selectedIds}`; 
        location.href = url;        
    }

    function getSelectedIds(dataGrid: DevExpress.ui.dxDataGrid, type: string) : string {
        if (type === "Drawing") {
            return dataGrid.getSelectedRowKeys().join(',');
        }

        return dataGrid.getSelectedRowsData().map(d => d.attachmentId).join(',');
    }    
}
